(function($, Drupal) {
  'use strict';
  const standardSort = 'asc-desc'
  let activeElement = '';
  let activeSort = standardSort;

  Drupal.behaviors.customFormSort = {
    attach: function (context, settings) {
      const sorter = $('#asc-desc-sort');
      $('select#sort-options').once().append($('.form-item-sort-by select').find('option').clone());
      if (activeElement.length > 0) {
        activeSort = standardSort;
        activeElement = '';
      }
      sorter.find('.active').removeClass('active');
      sorter.find(`.${activeSort}`).addClass('active');
    }
  }

  const setSortAsc = function() {
    activeSort = 'asc';
    $('.form-item-sort-order select option[selected=selected]').attr('selected', null);
    $('.form-item-sort-order select option[value=ASC]').attr('selected', 'selected');
    $('.primary-filter-button').click();
  };

  const setSortDesc = function(options) {
    activeSort = 'desc';
    $('.form-item-sort-order select option[selected=selected]').attr('selected', null);
    $('.form-item-sort-order select option[value=DESC]').attr('selected', 'selected');
    $('.primary-filter-button').click();
  };


  $('html').on('change', '.sort-options', function() {
    const formSortOptionElement = $('.form-item-sort-by select');
    activeElement = $('select#sort-options').find('option:selected').attr('value');
    formSortOptionElement.find('option[selected=selected]').attr('selected', null);
    formSortOptionElement.find('option[value=' + activeElement + ']').attr('selected', 'selected');
    $('.primary-filter-button').click();
  });

  $('html').on('click', '#asc-desc-sort', function() {
    switch (activeSort) {
      case 'asc':
        setSortDesc();
        break;
      case 'desc':
        setSortAsc();
        break;
      default:
        setSortAsc();
    }
  });

})(jQuery, Drupal);
